import { CHANGE_LANGUAGE } from "./constants";

const initialState = {
  language: "dk"
};

export default function preference(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload.language
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/preference/reducer.js